module.exports = __webpack_public_path__ + "static/media/02gsh.8cca991a.png";